module.exports = __webpack_public_path__ + "img/vue1-doublure_rose.f7ec5f18.png";